import { EmployeeSubject } from '@gokrew/models/employee-permissions';
import { createPermissionKeys } from '@gokrew/ui/utility/createPermissionKeys';

/**
 * Type-safe permission keys for the employee portal.
 */
export const permissionKeys = createPermissionKeys(
  Object.values(EmployeeSubject)
);
